import { Icon } from '@requity-homes/component-library';

export function BackArrow({ onClick, className }) {
  return (
    <div className={className} onClick={onClick}>
      <Icon glyph="orangeCircleArrow" className="w-5 h-5 cursor-pointer" />
    </div>
  );
}
